import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

const review = {
  namespaced: true,
  state: {
    reviews: [],
    loading: false,
  },
  mutations: {
    SET_REVIEWS(state, list) {
      state.reviews = Array.isArray(list) ? list : [];
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
  },
  getters: {
    getReviews: (state) => state.reviews,
    isLoading: (state) => state.loading,
  },
  actions: {
    fetchReviews: async ({ commit }, params = {}) => {
      commit('SET_LOADING', true);
      try {
        const query = new URLSearchParams(params).toString();
        const response = await backend.getReviews(query);
        await checkResponseStatus(200, response);
        commit('SET_REVIEWS', response.data || []);
        return response.data || [];
      } catch (e) {
        console.error('fetchReviews:', e);
        commit('SET_REVIEWS', []);
        return [];
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};

export default review;
